module.exports = __webpack_public_path__ + "img/164.346f470b.jpg";